import { GeocodeRequester } from '@cobliteam/api-lib';
import { Environment } from '@cobliteam/react-environments';
import { loadAddressFailed, loadAddressSucceeded } from '@cobliteam/store/src/VehiclePopup/actionCreators';
import type { LoadAddressRequest } from '@cobliteam/store/src/VehiclePopup/actions';
import { ActionTypes } from '@cobliteam/store/src/VehiclePopup/actionTypes';
import { all, call, put, throttle } from 'redux-saga/effects';
import { toast } from 'sonner';

const env = Environment.getInstance().getEnvironment();
const geocodeRequester = new GeocodeRequester({ host: env.herbieApiHost });

export function* requestLoadAddressSaga(action: LoadAddressRequest) {
  try {
    const { coordinate, disableCache } = action.payload;
    const { latitude: lat, longitude: lng } = coordinate;

    const address: string = yield call(geocodeRequester.getAddress, { lat, lng }, disableCache);

    yield put(loadAddressSucceeded(address));
  } catch (error) {
    yield put(loadAddressFailed());
    toast.error('Houve um erro, tente novamente mais tarde.');
  }
}

export function* VehiclePopupSagasListener() {
  // Geocoding is expensive, so we're throtling the saga to avoid costly headaches
  yield all([throttle(10000, ActionTypes.LOAD_ADDRESS_REQUEST, requestLoadAddressSaga)]);
}
